import { action as apiAction } from 'api/Api'

type Payload = {
  documentSourceId: number
  url: string
}

export default (payload: Payload) => async () => {
  const { documentSourceId, url } = payload

  await apiAction('RemoveFile', {
    documentsSourceId: documentSourceId,
    url
  })
}
